module.exports = __webpack_public_path__ + "img/404.2054c258.png";